import Vue from 'vue';
import { format, addDays } from 'date-fns';

export default Vue.filter('daysFromIssuedDate', (value, dateFrom, dateFormat) => {
  const days = parseInt(value, 10);

  if (Number.isNaN(days) || !dateFormat) return '';

  const startDate = dateFrom instanceof Date ? dateFrom : new Date(dateFrom);

  return format(addDays(startDate, days), dateFormat);
});
